export default function debounce<TParams, TReturn>(
  fn: (...params: TParams[]) => TReturn,
  time: number
) {
  let timerId: ReturnType<typeof setTimeout> | undefined = undefined;

  return [function (...args: TParams[]) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => fn(...args), time);
  }, function () {
    if (timerId) {
      clearTimeout(timerId);
    }
  }]
}
